// dependencies
import React, { useEffect, useState } from "react";

import SelectInput, { Result } from "../../../../../components/Inputs/SelectInput";

// store
import useQueryBuilderStore from "../store";

interface BaseProps {
	onChange: (value: any) => void;
	value: unknown;
}

const ReviewTemplatePicker = (props: BaseProps) => {
	const [fields, setFields] = useState<Result[]>([]);
	const { onChange, value } = props;

	const [fetchReviewTemplates] = useQueryBuilderStore((state) => [state.fetchReviewTemplates]);

	const getReviewTemplates = async () => {
		const reviewTemplates = await fetchReviewTemplates();
		setFields(reviewTemplates);
	};

	useEffect(() => {
		getReviewTemplates();
	}, []);

	return <SelectInput results={fields} onChange={onChange} value={value as Result} />;
};

export default ReviewTemplatePicker;
